import { render, staticRenderFns } from "./GustoPayout.vue?vue&type=template&id=6ba27d50&"
import script from "./GustoPayout.vue?vue&type=script&lang=ts&"
export * from "./GustoPayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports